import { Skeleton } from '@/components/ui/skeleton'

export const PremiosSkeleton = () => {
  return (
    <div className='borde-esforce-black-300 flex min-h-60 w-full rounded-xl border'>
      <Skeleton className='r h-full w-full flex-1 rounded-none rounded-s-xl bg-esforce-black-300' />

      <div className='flex flex-1 flex-col justify-between p-6'>
        <hgroup>
          <Skeleton className='mb-3 bg-esforce-black-300 p-4' />
          <div className='flex flex-col gap-1'>
            <div className='flex items-center gap-2 text-sm'>
              <Skeleton className='w-48 bg-esforce-black-300 p-3 text-xs font-normal text-esforce-white-100' />
            </div>
            <div className='flex items-center gap-2 text-sm text-zinc-300'>
              <Skeleton className='w-44 bg-esforce-black-300 p-3 text-xs font-normal text-esforce-white-100' />
            </div>
          </div>
        </hgroup>

        <Skeleton
          className={`mt-7 h-10 w-full cursor-pointer rounded-md bg-esforce-black-300 px-8 text-sm`}
        />
      </div>
    </div>
  )
}
